module.exports = __webpack_public_path__ + "static/media/communitycats.f24a05a0.jpg";